import React, { Component } from "react";
import { BrowserRouter, Route, Switch, Redirect, useLocation } from "react-router-dom";
import Requestimates from "./components/views/requestimates/requestimates";
import Campaigns from "./components/views/campaigns/Campaigns";
import Referrals from "./components/views/referrals/referrals";
import RequestimateForm from "./components/views/requestimates/requestimateForm";
import NavBar from "./components/partial/navBar";
import NavTop from "./components/partial/navTop";
import NavTopBar from "./components/partial/navTopBar";
import Calendar from "./components/views/calendar/calendar";
import Financials from "./components/views/financials/newFinancials";
import Vehicles from "./components/newVehicles";
import Customers from "./components/views/customer/newCustomers";
import Services from "./components/views/services/newServices";
import InventoryDashboard from "./components/views/inventory/InventoryDashboard";
import ReceiveInventory from "./components/views/inventory/ReceiveInventory";
import WalkInForm from "./components/views/requestimates/walkInForm";
import Users from "./components/Users";
import Profile from "./components/views/profile/ProfilePage";
import CheckInWizard from './components/views/checkin/CheckInWizard';
import StaffManagement from './components/views/staff/StaffManagement';
import StaffTimeDetail from './components/views/staff/StaffTimeDetail';
import TimeReports from './components/views/staff/TimeReports';
import MyWork from './components/views/technician/MyWork';
import MyTime from './components/views/technician/MyTime';
import History from './components/views/history/History';
import Dashboard from './components/views/dashboard/Dashboard';

// NEW: Import claim components for public routes
import ClaimPage from "./components/views/claim/ClaimPage";
import ClaimReferralPage from "./components/views/claim/ReferralClaimForm";
import PublicReferralForm from "./components/views/referrals/PublicReferralForm";
import DealerSignup from "./components/views/auth/DealerSignup";
import DealerWelcome from "./components/views/auth/DealerWelcome";
import EstimateChatbot from "./components/views/estimates/EstimateChatbot";
import PublicQuoteAccept from "./components/views/quotes/PublicQuoteAccept";

import OBDPanel from "./components/partial/OBDPanel";

import "./assets/css/App.css";
import ReactGA from "react-ga4";
import VersionChecker from "./components/partial/VersionChecker";
import { version } from "../package.json";
import { HTTPService } from "./services/httpService";
import EditJob from "./components/views/requestimates/editJob";
import ContractForm from "./components/views/requestimates/contractForm";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const API = new HTTPService();

const RELEASE_NOTES_URL = "https://s3.us-east-2.amazonaws.com/jobvious.digitalassets/Jobvious_Release_Notes.pdf";

const PAGE_TITLES = {
  '/requestimates': 'Requests',
  '/jobs': 'Jobs',
  '/pickups': 'Pickups',
  '/reviews': 'Reviews',
  '/calendar': 'Calendar',
  '/financials': 'Financials',
  '/dashboard': 'Dashboard',
  '/history': 'History',
  '/profile': 'Profile',
  '/services': 'Services',
  '/vehicles': 'Vehicles',
  '/customers': 'Customers',
  '/referrals': 'Referrals',
  '/campaigns': 'Campaigns',
  '/inventory': 'Inventory',
  '/staff': 'Staff',
  '/mywork': 'My Work',
  '/mytime': 'My Time',
  '/users': 'Users',
  '/newrequestimates': 'New Request',
  '/newestimate': 'Walk-In',
  '/editJob': 'Edit Job',
  '/estimate': 'Estimate',
  '/checkin': 'Check-In',
};

const PageTitle = () => {
  const location = useLocation();
  React.useEffect(() => {
    const path = location.pathname;
    const match = Object.keys(PAGE_TITLES).find(key => path.startsWith(key));
    document.title = match ? `${PAGE_TITLES[match]} | Jobvious` : 'Jobvious';
  }, [location.pathname]);
  return null;
};

const UpdateToast = () => {
  React.useEffect(() => {
    const updatedVersion = localStorage.getItem("jobvious_updated_version");
    if (updatedVersion) {
      localStorage.removeItem("jobvious_updated_version");
      toast.info(
        <div>
          <strong>Updated to v{updatedVersion}</strong>
          <br />
          <span
            onClick={() => window.open(RELEASE_NOTES_URL, "_blank")}
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            Click to read the Release Notes
          </span>
        </div>,
        { autoClose: 10000 }
      );
    }
  }, []);
  return null;
};

require("dotenv").config();

class App extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props, context) {
    super(props, context);
  }


  state = (() => {
    // Read location state synchronously so the first render has correct values
    let locations = [];
    let selectedLocationId = null;
    try {
      const company = JSON.parse(localStorage.getItem('companyAPI'));
      if (company && company.locations) {
        locations = company.locations;
        selectedLocationId = company.selectedLocationId || null;
      }
    } catch { /* no-op */ }
    return {
      selectedRequest: "",
      sidebarCollapsed: false,
      locations,
      selectedLocationId,
      obdPanelOpen: false,
    };
  })();

  componentDidMount() {
    window.addEventListener('sidebarToggled', this.handleSidebarToggle);
  }

  componentWillUnmount() {
    window.removeEventListener('sidebarToggled', this.handleSidebarToggle);
  }

  handleSidebarToggle = (event) => {
    this.setState({ sidebarCollapsed: event.detail.collapsed });
  };

  handleOBDToggle = () => {
    this.setState(prev => ({ obdPanelOpen: !prev.obdPanelOpen }));
  };

  handleLocationChange = (locationId) => {
    // Update localStorage then reload so all components re-fetch for the new location
    try {
      const company = JSON.parse(localStorage.getItem('companyAPI'));
      if (company) {
        company.selectedLocationId = locationId;
        localStorage.setItem('companyAPI', JSON.stringify(company));
      }
    } catch { /* no-op */ }

    window.location.reload();
  };

  handleChange = async (newCompany, userType, targetLocationId = null) => {

    console.log ("App : HandleChange : company :", newCompany);
    //console.log ("App : HandleChange : userType :", userType);


    let getCompany = '/installers/';
    if (userType === 'dealer')
      getCompany = "/dealers/";
    let response = await API.get(`${getCompany}${newCompany}`);

    // Company installer
    const company = response.data;
    let name = "";
    if (userType === "dealer")
      name = company[0].dealer_name
    else
      name = company[0].Installer_Name;

    const companyName = name.replace(
      / /g,
      "_"
    ).toLowerCase();

    // For installers, fetch locations and Stripe status in parallel
    if (userType !== 'dealer') {
      try {
        const [stripeRes, locationsRes] = await Promise.all([
          API.get(`/api/installers/${newCompany}/stripe-status`).catch(() => ({ data: {} })),
          API.get(`/installers/${newCompany}/locations`).catch(() => ({ data: [] }))
        ]);
        localStorage.setItem("stripeCapabilities", JSON.stringify(stripeRes.data || {}));

        // Store locations in companyAPI
        const locations = locationsRes.data || [];
        company[0].locations = locations;
        if (targetLocationId) {
          const validTarget = locations.find(l => String(l.location_id) === String(targetLocationId));
          company[0].selectedLocationId = validTarget ? targetLocationId : (locations.length > 0 ? locations[0].location_id : null);
        } else {
          // null means installer-level (all locations) — preserve it
          company[0].selectedLocationId = null;
        }
      } catch {
        localStorage.setItem("stripeCapabilities", JSON.stringify({}));
      }
    }

    localStorage.setItem("companyAPI", JSON.stringify(company[0]));
    localStorage.setItem("named_user_id", JSON.stringify(companyName));

    window.location = "/requestimates";
  };

  handleRequest = async (request) => {
    this.setState({ selectedRequest: request });
  };


isPublicRoute = () => {
  const path = window.location.pathname;
  console.log("Path being tested:", path);

  // Test each path individually to see which one breaks
  try {
    const publicPaths = ['/referralclaim', '/claim', '/public/referral', '/signup/dealer', '/welcome', '/estimate'];
    console.log("Public paths array:", publicPaths);

    for (let i = 0; i < publicPaths.length; i++) {
      console.log(`Testing path ${i}: ${publicPaths[i]}`);
      const matches = path.startsWith(publicPaths[i]);
      console.log(`Does '${path}' start with '${publicPaths[i]}'? ${matches}`);

      if (matches) {
        console.log("Found match, returning true");
        return true;
      }
    }

    console.log("No matches found, returning false");
    return false;
  } catch (error) {
    console.error("Error in isPublicRoute:", error);
    return false;
  }
};

// Here's a much cleaner approach - just modify your existing render method:

render() {
  const currentPath = window.location.pathname;
  console.log("🔍 Current path on render:", currentPath);
  
  ReactGA.initialize(process.env.REACT_APP_GA);

  setTimeout(() => {
    // Checks if login process has finished, if not, returns to login
    if (
      (!window.localStorage.getItem("userAPI") ||
        !window.localStorage.getItem("companyAPI")) &&
      window.localStorage.getItem("amplify-authenticator-authState") ===
        "signedIn"
    ) {
      window.localStorage.clear();
      window.location.reload();
    }
  }, 5000);

  const user = JSON.parse(localStorage.getItem("userAPI"));
  const company = JSON.parse(localStorage.getItem("companyAPI"));

  return (
    <React.Fragment>
      <BrowserRouter>
        <PageTitle />
        <VersionChecker />
        <UpdateToast />
        <ToastContainer position="top-right" autoClose={8000} />
        <div className="App">
          <Switch>
            {/* PUBLIC ROUTES FIRST - No authentication required */}
            <Route path="/claim" component={ClaimPage} />
            <Route path="/referralclaim" component={ClaimReferralPage} />
            <Route path="/public/referral" component={PublicReferralForm} />
            <Route path="/quote/:requestId/accept/:token" component={PublicQuoteAccept} />
            <Route path="/signup/dealer" component={DealerSignup} />
            <Route path="/welcome" component={DealerWelcome} />
            <Route path="/estimate" component={EstimateChatbot} />
            
            {/* AUTHENTICATED ROUTES - All other routes require authentication */}
            <Route 
              path="/"
              render={(props) => {
                // Check if user is authenticated
                if (this.props.authState === "signedIn" && user && company) {
                  
                  let companyName = "";
                  let typeId = "";
                  let capacity = 0;
                  let authenticated = 0;
                  let userCalendar = "";
                  const dealerGroupInfo = JSON.parse(localStorage.getItem("dealerGroupAPI") || "null");
                  const userType = (dealerGroupInfo && dealerGroupInfo.isDealerGroup)
                    ? 'dealer_group'
                    : user.User_type;
                  console.log("Here's the company record", company);

                  if (userType === "dealer" || userType === "dealer_group") {
                    companyName = dealerGroupInfo ? (dealerGroupInfo.groupName || company.dealer_name) : company.dealer_name;
                    typeId = company.dealer_id;
                  } else {
                    companyName = company.Installer_Name;
                    typeId = company.Installer_id;
                    capacity = company.capacity;
                    authenticated = company.Authenticated;
                    userCalendar = company.calendar_id;
                  }

                  const selectedReferral = {};

                  // Multi-location props
                  const locations = this.state.locations;
                  const selectedLocationId = this.state.selectedLocationId;

                  // Dealer role access helpers
                  const dealerRole = (user.role || '').toLowerCase();
                  const isDealerContact = userType === 'dealer' && dealerRole === 'contact';

                  return (
                    <div className="container-fluid">
                      <div className="row">
                        {/* Mobile */}
                        <div className="col-lg-12 d-lg-none p-0">
                          <NavTopBar
                            title={companyName}
                            userType={userType}
                            userId={user.User_id}
                            userName={user.user_name}
                            access={user.access}
                            userRole={user.role}
                            onSwitch={this.handleChange}
                            locations={locations}
                            selectedLocationId={selectedLocationId}
                            onLocationChange={this.handleLocationChange}
                          />
                        </div>

                        {/* Display LG */}
                        <div className={`bg-sidebar p-0 d-none d-lg-block ${this.state.sidebarCollapsed ? 'sidebar-col-collapsed' : 'col-lg-2'}`}>
                          <NavBar
                            userType={userType}
                            userId={user.User_id}
                            access={user.access}
                            userRole={user.role}
                            entityId={typeId}
                            authenticated={authenticated}
                            selectedLocationId={selectedLocationId}
                            {...this.props}
                          />
                        </div>

                        <div className={`p-0 wrapper ${this.state.sidebarCollapsed ? 'content-col-expanded' : 'col-lg-10'}`}>
                          <NavTop
                            title={companyName}
                            userId={user.User_id}
                            userName={user.user_name}
                            access={user.access}
                            onSwitch={this.handleChange}
                            userType={userType}
                            userRole={user.role}
                            locations={locations}
                            selectedLocationId={selectedLocationId}
                            onLocationChange={this.handleLocationChange}
                            showOBD={this.state.obdPanelOpen}
                            onOBDToggle={this.handleOBDToggle}
                          />

                          {userType === 'installer' && (user.role === 'admin' || user.role === 'owner' || user.access === 'ADMIN') && (
                            <OBDPanel
                              show={this.state.obdPanelOpen}
                              onClose={() => this.setState({ obdPanelOpen: false })}
                              installerId={typeId}
                              locationId={selectedLocationId}
                            />
                          )}

                          <div className="p-2">
                            {/* Dealer contact role: no page access */}
                            {isDealerContact ? (
                              <div className="text-center py-5">
                                <i className="fa-sharp fa-regular fa-lock fa-3x text-muted mb-3 d-block"></i>
                                <h5>No Access</h5>
                                <p className="text-muted">Your account is set up as a contact only. Please speak to your manager for access.</p>
                              </div>
                            ) : (
                            <Switch>
                              <Route
                                path="/settings/qbo"
                                render={({ location }) => {
                                  const params = new URLSearchParams(location.search);
                                  if (params.get('connected')) {
                                    return <Redirect to="/profile?qbo_connected=true" />;
                                  }
                                  if (params.get('error')) {
                                    return <Redirect to={`/profile?qbo_error=${encodeURIComponent(params.get('message') || 'Connection failed')}`} />;
                                  }
                                  return <Redirect to="/profile" />;
                                }}
                              />
                              <Route
                                path="/profile"
                                render={(props) => (
                                  <Profile
                                    userType={userType}
                                    userRole={user.role}
                                    access={user.access}
                                    userId={user.User_id}
                                    entityId={typeId}
                                    typeId={typeId}
                                    authenticated={authenticated}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />

                              <Route
                                path="/campaigns"
                                render={(props) => (
                                  <Campaigns
                                    user={user}
                                    userType={userType}
                                    typeId={typeId}
                                    access={user.access}
                                    authenticated={authenticated}
                                    company={company}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/calendar"
                                render={(props) => {
                                  if (userType === 'installer' && user.role === 'technician') {
                                    return <Redirect to="/mywork" />;
                                  }
                                  return (
                                    <Calendar
                                      userType={userType}
                                      typeId={typeId}
                                      authenticated={authenticated}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/financials"
                                render={(props) => {
                                  if (userType === 'installer' && user.role === 'technician') {
                                    return <Redirect to="/mywork" />;
                                  }
                                  return (
                                    <Financials
                                      userType={userType}
                                      user={user}
                                      access={user.access}
                                      typeId={typeId}
                                      company={company}
                                      groupId={dealerGroupInfo ? dealerGroupInfo.groupId : null}
                                      groupName={dealerGroupInfo ? dealerGroupInfo.groupName : null}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/dashboard"
                                render={(props) => {
                                  if (userType === 'installer' && user.role === 'technician') {
                                    return <Redirect to="/mywork" />;
                                  }
                                  return (
                                    <Dashboard
                                      userType={userType}
                                      user={user}
                                      typeId={typeId}
                                      company={company}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/history"
                                render={(props) => {
                                  // Only allow managers/owners, not technicians
                                  if (userType === 'installer' && user.role === 'technician') {
                                    return <Redirect to="/mywork" />;
                                  }
                                  return (
                                    <History
                                      userType={userType}
                                      user={user}
                                      entityId={typeId}
                                      company={company}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/requests/:requestId/checkin"
                                render={(props) => (
                                  <CheckInWizard
                                    company={company}
                                    user={user}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/customers"
                                render={(props) => (
                                  <Customers
                                    userType={userType}
                                    typeId={typeId}
                                    userRole={user.role}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/services"
                                render={(props) => {
                                  if (userType === 'installer' && ['viewer', 'technician'].includes(user.role)) {
                                    return <Redirect to="/requestimates" />;
                                  }
                                  return (
                                    <Services
                                      userType={userType}
                                      typeId={typeId}
                                      access={user.access}
                                      user={user}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/inventory/receive"
                                render={(props) => {
                                  // Viewers cannot access inventory
                                  if (userType === 'installer' && user.role === 'viewer') {
                                    return <Redirect to="/requestimates" />;
                                  }
                                  return (
                                    <ReceiveInventory
                                      userType={userType}
                                      typeId={typeId}
                                      user={user}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/inventory"
                                render={(props) => {
                                  // Viewers cannot access inventory
                                  if (userType === 'installer' && user.role === 'viewer') {
                                    return <Redirect to="/requestimates" />;
                                  }
                                  return (
                                    <InventoryDashboard
                                      userType={userType}
                                      typeId={typeId}
                                      user={user}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/staff/time-reports"
                                render={(props) => (
                                  <TimeReports
                                    userType={userType}
                                    typeId={typeId}
                                    user={user}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/staff/:userId/time"
                                render={(props) => (
                                  <StaffTimeDetail
                                    userType={userType}
                                    typeId={typeId}
                                    user={user}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/staff"
                                render={(props) => {
                                  // Staff page: installers must be admin, owner, or manager (legacy access === 'ADMIN' also qualifies)
                                  if (userType === 'installer' && user.access !== 'ADMIN' && !['admin', 'owner', 'manager'].includes(user.role)) {
                                    return <Redirect to="/requestimates" />;
                                  }
                                  // Dealer staff: only manager, admin, finance (legacy ADMIN access also qualifies)
                                  if (userType === 'dealer' && user.access !== 'ADMIN' && !['manager', 'admin', 'finance'].includes(dealerRole)) {
                                    return <Redirect to="/requestimates" />;
                                  }
                                  return (
                                    <StaffManagement
                                      userType={userType}
                                      typeId={typeId}
                                      user={user}
                                      companyName={companyName}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/mywork"
                                render={(props) => (
                                  <MyWork
                                    userType={userType}
                                    typeId={typeId}
                                    user={user}
                                    companyName={companyName}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/mytime"
                                render={(props) => (
                                  <MyTime
                                    user={user}
                                    typeId={typeId}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/vehicles"
                                render={(props) => (
                                  <Vehicles
                                    userType={userType}
                                    typeId={typeId}
                                    userRole={user.role}
                                    access={user.access}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/users"
                                render={(props) => (
                                  <Users
                                    userType={userType}
                                    typeId={typeId}
                                    user={user}
                                    {...props}
                                  />
                                )}
                              />
                              <Route path="/jobs"
                                render={(props) => {
                                  // Redirect technicians to their My Work view
                                  if (userType === 'installer' && user.role === 'technician') {
                                    return <Redirect to="/mywork" />;
                                  }
                                  return (
                                    <Requestimates
                                      mode="jobs"
                                      userType={userType}
                                      user={user}
                                      companyName={companyName}
                                      company={company}
                                      authenticated={authenticated}
                                      calendar={userCalendar}
                                      typeId={typeId}
                                      selectRequest={this.handleRequest}
                                      selectedRequest={this.state.selectedRequest}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/pickups"
                                render={(props) => (
                                  <Requestimates
                                    mode="pickups"
                                    userType={userType}
                                    user={user}
                                    companyName={companyName}
                                    company={company}
                                    authenticated={authenticated}
                                    calendar={userCalendar}
                                    typeId={typeId}
                                    selectRequest={this.handleRequest}
                                    selectedRequest={this.state.selectedRequest}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/reviews"
                                render={(props) => (
                                  <Requestimates
                                    mode="reviews"
                                    userType={userType}
                                    user={user}
                                    companyName={companyName}
                                    company={company}
                                    authenticated={authenticated}
                                    calendar={userCalendar}
                                    typeId={typeId}
                                    selectRequest={this.handleRequest}
                                    selectedRequest={this.state.selectedRequest}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/newrequestimates"
                                render={(props) => (
                                  <RequestimateForm
                                    userType={userType}
                                    user={user}
                                    userAccess={user.access}
                                    companyName={companyName}
                                    company={company}
                                    typeId={typeId}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/newestimate"
                                render={(props) => (
                                  <WalkInForm
                                    userType={userType}
                                    user={user}
                                    capacity={capacity}
                                    companyName={companyName}
                                    company={company}
                                    typeId={typeId}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/requestimates"
                                render={(props) => {
                                  // Redirect technicians to their My Work view
                                  if (userType === 'installer' && user.role === 'technician') {
                                    return <Redirect to="/mywork" />;
                                  }
                                  return (
                                    <Requestimates
                                      mode="requests"
                                      userType={userType}
                                      user={user}
                                      typeId={typeId}
                                      company={company}
                                      companyName={companyName}
                                      authenticated={authenticated}
                                      calendar={userCalendar}
                                      onSwitch={this.handleChange}
                                      selectRequest={this.handleRequest}
                                      selectedRequest={this.state.selectedRequest}
                                      locations={locations}
                                      selectedLocationId={selectedLocationId}
                                      {...props}
                                    />
                                  );
                                }}
                              />
                              <Route
                                path="/referrals"
                                render={(props) => (
                                  <Referrals
                                    mode="referrals"
                                    userType={userType}
                                    user={user}
                                    typeId={typeId}
                                    companyName={companyName}
                                    company={company}
                                    authenticated={authenticated}
                                    selectedReferral={selectedReferral}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/editJob/:requestId"
                                render={(props) => (
                                  <EditJob
                                    mode="requests"
                                    userType={userType}
                                    user={user}
                                    companyName={companyName}
                                    company={company}
                                    authenticated={authenticated}
                                    calendar={userCalendar}
                                    typeId={typeId}
                                    locations={locations}
                                    selectedLocationId={selectedLocationId}
                                    {...props}
                                  />
                                )}
                              />
                              <Route
                                path="/contract/:requestId"
                                render={(props) => (
                                  <ContractForm
                                    mode="requests"
                                    userType={userType}
                                    user={user}
                                    companyName={companyName}
                                    company={company}
                                    authenticated={authenticated}
                                    calendar={userCalendar}
                                    typeId={typeId}
                                    {...props}
                                  />
                                )}
                              />
                              {/* Default route for authenticated users */}
                              {/* Dealer group → financials, Technicians → mywork, others → requestimates */}
                              <Route exact path="/" render={() => {
                                if (userType === 'dealer_group') return <Redirect to="/financials" />;
                                if (userType === 'installer' && user.role === 'technician') return <Redirect to="/mywork" />;
                                return <Redirect to="/requestimates" />;
                              }} />
                            </Switch>
                            )}
                          </div>

                          <div className="col-lg-12 mt-5 text-center">
                            <p>&copy; 2026 {user && (user.Email === 'installer@jobvious.com' || user.Email === 'dealer@jobvious.com') ? 'Powered by Jobvious' : 'Jobvious, Inc'} (v {version}) </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                } else {
                  console.log("Not signed in or no user/company data");
                  return null;
                }
              }}
            />
          </Switch>
        </div>
      </BrowserRouter>
    </React.Fragment>
  );
}
}
export default App;
